import { Injectable, OnDestroy } from '@angular/core';
import { Subject, BehaviorSubject, fromEvent } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { Router } from '@angular/router';
import { User } from '../../services/auth-api/models/user.model';
import { RoleEnum } from '../../services/auth-api/enums/role.enum';

// Menu
export interface Menu {
  headTitle1?: string;
  headTitle2?: string;
  path?: string;
  title?: string;
  icon?: string;
  type?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  children?: Menu[];
  permission?: string;
}

@Injectable({
  providedIn: 'root',
})
export class NavService implements OnDestroy {
  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(
    window.innerWidth,
  );

  // Search Box
  public search: boolean = false;

  // Language
  public language: boolean = false;

  // Mega Menu
  public megaMenu: boolean = false;
  public levelMenu: boolean = false;
  public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

  // Collapse Sidebar
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  // For Horizontal Layout Mobile
  public horizontal: boolean = window.innerWidth < 991 ? false : true;

  // Full screen
  public fullScreen: boolean = false;

  user: User | undefined = localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user') ?? '')
    : undefined;

  constructor(private router: Router) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, 'resize')
      .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 991) {
          this.collapseSidebar = true;
          this.megaMenu = false;
          this.levelMenu = false;
        }
        if (evt.target.innerWidth < 1199) {
          this.megaMenuColapse = true;
        }
      });
    if (window.innerWidth < 991) {
      // Detect Route change sidebar close
      this.router.events.subscribe((event) => {
        this.collapseSidebar = true;
        this.megaMenu = false;
        this.levelMenu = false;
      });
    }
  }

  ngOnDestroy() {
    // this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  MENUITEMS: Menu[] = [
    {
      headTitle1: 'Geral',
    },
    {
      path: 'chat',
      title: 'Chat.MenuTitle',
      icon: 'message-circle',
      type: 'link',
    },
    {
      path: 'schedules',
      title: 'MailPhaseMenuTitle',
      icon: 'send',
      type: 'link',
      permission: 'GESTION/MAILPHASE',
    },
    // Examples
    // {
    //   title: 'Dashboards',
    //   icon: 'home',
    //   type: 'sub',
    //   badgeType: 'light-primary',
    //   badgeValue: '5',
    //   active: true,
    //   children: [
    //     { path: '/dashboard/default', title: 'Default', type: 'link' },
    //     { path: '/dashboard/ecommerce', title: 'Ecommerce', type: 'link' },
    //     {
    //       path: '/dashboard/online-course',
    //       title: 'Online course',
    //       type: 'link',
    //     },
    //     { path: '/dashboard/crypto', title: 'Crypto', type: 'link' },
    //     { path: '/dashboard/social', title: 'Social', type: 'link' },
    //   ],
    // },
    // {
    //   title: 'Widgets',
    //   icon: 'widget',
    //   type: 'sub',
    //   active: false,
    //   children: [
    //     { path: '/widgets/general', title: 'General', type: 'link' },
    //     { path: '/widgets/chart', title: 'Chart', type: 'link' },
    //   ],
    // },
    // {
    //   path: '/file-manager',
    //   title: 'File Manager',
    //   icon: 'file',
    //   type: 'link',
    // },
    // {
    //   title: 'Forms',
    //   icon: 'form',
    //   type: 'sub',
    //   active: false,
    //   children: [
    //     {
    //       title: 'Form Controls',
    //       icon: 'file-text',
    //       type: 'sub',
    //       active: false,
    //       children: [
    //         {
    //           path: '/form/form-controls/validation',
    //           title: 'Form Validation',
    //           type: 'link',
    //         },
    //         {
    //           path: '/form/form-controls/inputs',
    //           title: 'Base Inputs',
    //           type: 'link',
    //         },
    //         {
    //           path: '/form/form-controls/checkbox-radio',
    //           title: 'Checkbox & Radio',
    //           type: 'link',
    //         },
    //         {
    //           path: '/form/form-controls/input-groups',
    //           title: 'Input Groups',
    //           type: 'link',
    //         },
    //         {
    //           path: '/form/form-controls/mega-options',
    //           title: 'Mega Options',
    //           type: 'link',
    //         },
    //       ],
    //     },
    //     {
    //       title: 'Form Widgets',
    //       icon: 'file-text',
    //       type: 'sub',
    //       active: false,
    //       children: [
    //         {
    //           path: '/form/form-widgets/touchspin',
    //           title: 'Touchspin',
    //           type: 'link',
    //         },
    //         {
    //           path: '/form/form-widgets/ngselect',
    //           title: 'Ng-Select',
    //           type: 'link',
    //         },
    //         {
    //           path: '/form/form-widgets/switch',
    //           title: 'Switch',
    //           type: 'link',
    //         },
    //         {
    //           path: '/form/form-widgets/clipboard',
    //           title: 'Clipboard',
    //           type: 'link',
    //         },
    //       ],
    //     },
    //     {
    //       title: 'Form Layout',
    //       icon: 'file-text',
    //       type: 'sub',
    //       active: false,
    //       children: [
    //         {
    //           path: '/form/form-layout/default-form',
    //           title: 'Default Forms',
    //           type: 'link',
    //         },
    //       ],
    //     },
    //   ],
    // },
  ];

  // Array
  items = new BehaviorSubject<Menu[]>(
    this.MENUITEMS.filter(
      (x) =>
        (!x.permission && !x.children?.find((x2) => !x2.permission)) ||
        (this.user?.roles &&
          this.user.roles.includes(RoleEnum[RoleEnum.Admin])) ||
        (x.permission &&
          this.user?.permissions &&
          this.user.permissions.includes(x.permission)) ||
        (x.children?.find((x2) => x2.permission) &&
          this.user?.permissions &&
          x.children?.find(
            (x2) =>
              x2.permission && this.user!.permissions.includes(x2.permission),
          )),
    ).map((item) => {
      if (item.children)
        item.children = item.children.filter(
          (x) =>
            !x.permission ||
            (this.user?.roles &&
              this.user.roles.includes(RoleEnum[RoleEnum.Admin])) ||
            (this.user?.permissions &&
              this.user.permissions.includes(x.permission)),
        );
      return item;
    }),
  );
}
